import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CpInputDisclaimerGroupComponent } from 'src/app/cp-inputdisclaimergroup/cp-inputdisclaimergroup.component';
import { TaskItem } from 'src/app/Task/taskcommon/taskcommon.class';
import { InputItem } from '../inputcommon/inputcommon.class';
import { InputTasks } from './inputtask';
import { InputTasksService } from './inputtasks.service';
import { InputTasksItem } from './inputtasksitem';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-inputtasks',
    templateUrl: './inputtasks.component.html',
    styleUrls: ['./inputtasks.component.css'],
    standalone: false
})
export class InputTasksComponent extends PageBase  implements OnInit, OnChanges {

  @ViewChild('inputDisclaimerGroup') inputDisclaimerGroup: CpInputDisclaimerGroupComponent;
  @Input() InputItem: InputItem;
  inputTasks = new InputTasks();
  itemsTasks: Array<TaskItem>;
  isHideLoading: boolean;
  isHideLoadingVejaMais: boolean;
  placeholderTaskInput: string;
  filtersListTask: Array<string>;

  constructor(private inputTaskService: InputTasksService,
              public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.itemsTasks = [];
    this.inputTasks.items = new Array<InputTasksItem>();
    this.inputTasks.hasNext = false;
    this.placeholderTaskInput = this.literalsCp?.strPlaceHolderInputTask;
    this.filtersListTask = new Array<string>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.InputItem.currentValue['inputId']) {
      this.isHideLoading = false;
      this.isHideLoadingVejaMais = true;
      this.GetInputTask();
      this.inputDisclaimerGroup.clearDisclaimerGroup();
    }
  }


  private GetInputTask() {
    this.inputTaskService.ResetPages();
    this.inputTaskService.GetInfoInputTask(this.InputItem).then(
      result => {
        this.inputTasks = result;
        this.RefreshListTasks();
        this.isHideLoading = true;
      }
    );
  }

  private RefreshListTasks() {
    this.itemsTasks = [];
    this.inputTasks?.items.forEach(element => {
      this.itemsTasks.push(this.CreateTaskItem(element));
    });
  }

  load() {
    this.isHideLoadingVejaMais = false;
    if(this.filtersListTask.length > 0)
    {
      this.inputTaskService.GetInfoTaskInputWithCostGroup(this.InputItem, this.filtersListTask).then(
        result => {
          this.inputTasks.hasNext = result?.hasNext;
          this.inputTasks.total = result?.total;
          this.inputTasks.items = this.inputTasks.items.concat(result?.items);
          this.ConcatenateListInputs(result?.items);
          this.isHideLoadingVejaMais = true;
        }
      );
    }
    else {
      this.inputTaskService.GetInfoInputTask(this.InputItem).then(
        result => {
          this.inputTasks.hasNext = result?.hasNext;
          this.inputTasks.total = result?.total;
          this.inputTasks.items = this.inputTasks.items.concat(result?.items);
          this.ConcatenateListInputs(result?.items);
          this.isHideLoadingVejaMais = true;
        }
      );
    }

  }

  private ConcatenateListInputs(inputTaskItems: InputTasksItem[]) {
    inputTaskItems.forEach(x => this.itemsTasks = this.itemsTasks.concat(this.CreateTaskItem(x)));
  }

  CreateTaskItem(inputTaskItem: InputTasksItem): TaskItem {
    const taskInfo = new TaskItem();
    taskInfo.companyid = inputTaskItem.companyId;
    taskInfo.taskDescription = inputTaskItem.taskDescription;
    taskInfo.taskCode = inputTaskItem.taskCode;
    taskInfo.taskid = inputTaskItem.taskId;
    taskInfo.projectid = inputTaskItem.projectId;
    taskInfo.taskName = inputTaskItem.taskName;
    taskInfo.inputId = inputTaskItem.inputId;
    return taskInfo;
  }

  GetFiltersTask(filters: Array<string>) {
    this.isHideLoading = false;
    this.filtersListTask = [];
    if(filters.length > 0) {
      filters.forEach(item => this.filtersListTask.push(item['value']));
      this.inputTaskService.ResetPages();
      this.inputTaskService.GetInfoTaskInputWithCostGroup(this.InputItem, this.filtersListTask).then(
        result => {
          this.inputTasks = result;
          this.RefreshListTasks();
          this.isHideLoading = true;
        }
      );
    }
    else {
      this.GetInputTask();
    }

  }

  onReceiveLiterals(): void {}

}
